export const Routes = {
    SEND_LOGIN_OTP: "/public/user/send-otp",
    SEND_SIGNUP_OTP: "/public/user/signup/mobile",
    DECODE: "/public/decode",
    VERIFY_OTP: "/public/user/verify-otp",
    REFRESH_TOKEN: "/public/user/refreshtoken",
    SIGNUP_VERIFY_OTP: "/public/user/signup/mobile/verify/redirection",
    LINKED_ACCOUNTS: "/User/linkedaccount",
    DISCOVER_ACCOUNTS: "/User/account/discovery",
    LINK_ACCOUNTS: "/User/account/link",
    CONFIRM_LINKING: "/User/account/link/",
    CONSENT_REQUEST_DETAILS: "/User/Consent/handle",
    CONSENT_APPROVAL: "/User/Consent/Approval/Verification",
    SIGN_OUT: "/User/sign-out",
    USER_INFO: "/User",
    IDENTIFIERS: "/User/Identifiers",
    IDENTIFIERS_VERIFY: "/User/Identifiers/Verify",
};
export const OPEN_URLS = [Routes.SEND_LOGIN_OTP, Routes.SEND_SIGNUP_OTP, Routes.DECODE, Routes.VERIFY_OTP];
//# sourceMappingURL=RouteConstants.js.map